/* eslint-disable no-unused-vars */
import React from 'react';
import LogInForm from './components/LogInForm';

const LogIn = () => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <img src="/img/logo/logo.png" alt="" />
        <div style={{ paddingTop: '16px' }}>
          <LogInForm />
        </div>
      </div>
    </div>
  </div>
);

export default LogIn;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
